import { add, startOfDay } from 'date-fns';

import { RangeHorizon } from '~/ui/components/resample-selector/ResampleSelector.types';

import { i18n } from '../';

export const formatXAxisPoint = (date: Date) =>
  `${date.toLocaleString(i18n.resolvedLanguage, {
    weekday: 'short',
    timeZone: 'UTC',
  })} ${date.getUTCDate()} ${date.toLocaleString(i18n.resolvedLanguage, {
    month: 'short',
    timeZone: 'UTC',
  })}'${date.getUTCFullYear().toString().slice(-2)}`;

const getTimeMinusOffset = (date: Date): number =>
  date.getTime() - date.getTimezoneOffset() * 60 * 1000;

export function getStartOfRangeHorizon(horizon: RangeHorizon, from: Date) {
  const mapping: Partial<Record<RangeHorizon, () => Date>> = {
    [RangeHorizon.OneDay]: () => add(from, { days: -1 }),
    [RangeHorizon.OneWeek]: () => add(from, { days: -7 }),
    [RangeHorizon.OneMonth]: () => add(from, { months: -1, days: 1 }),
    [RangeHorizon.ThreeMonths]: () => add(from, { months: -3, days: 1 }),
    [RangeHorizon.SixMonths]: () => add(from, { months: -6, days: 1 }),
    [RangeHorizon.OneYear]: () => add(from, { years: -1, days: 1 }),
    [RangeHorizon.ThreeYears]: () => add(from, { years: -3, days: 1 }),
    [RangeHorizon.FiveYears]: () => add(from, { years: -5, days: 1 }),
    [RangeHorizon.TenYears]: () => add(from, { years: -10, days: 1 }),
  };

  const startDate = mapping[horizon]?.();
  const startOfLocalDay = startDate && startOfDay(startDate);
  return startOfLocalDay && getTimeMinusOffset(startOfLocalDay);
}
